<template>
  <v-container>
    <v-row dense class="mt-9" v-if="loading" alig="center" justify="center">
      <v-row>
        <v-col>
          <v-skeleton-loader
            type="table-heading, list-item-two-line, image, table-tfoot"
          ></v-skeleton-loader>
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-row>
    <div v-else>
      <v-row class="mt-9">
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col class="d-flex align-center justify-center">
              <v-card
                min-width="80vw"
                elevation="1"
                style="border-radius: 30px; background-color: transparent"
              >
                <v-card-title>
                  <v-toolbar
                    background="transparent"
                    style="border-radius: 24px 24px 0px 0px"
                    class="toolbar"
                  >
                    <v-col class="d-flex align-center justify-start">
                      <span class="white--text text-h4">
                        {{ subtitle }}</span
                      > </v-col
                    ><v-spacer> </v-spacer>
                  </v-toolbar>
                </v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="2">
                      <v-avatar size="200" style="background-color: whitesmoke">
                        <v-img
                          src="@/assets/images/connect/partner/pitch_icon_form.svg"
                          height="20vh"
                          contain
                        />
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <v-row class="ma-0 pa-0" dense>
                        <v-col>
                          <custom-input
                            label="Iniciada em"
                            :currentValue="form.createdAt"
                            readonly
                            disabled
                          />
                        </v-col>
                        <v-col
                          ><custom-select
                            label="Nível"
                            :dense="true"
                            :items="englishLevels"
                            :itemText="`text`"
                            :itemValue="`value`"
                            :currentValue="form.level"
                            v-model="form.level"
                            disabled
                          />
                        </v-col>
                        <v-col>
                          <custom-select
                            label="Plano de ensino"
                            :dense="true"
                            :items="teachingPlans"
                            :itemText="`text`"
                            :itemValue="`value`"
                            :currentValue="selectedPlan"
                            :returnObject="true"
                            @input="setCurrentPlan"
                          />
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col>
                          <custom-select
                            label="Modalidade"
                            v-model="form.format"
                            :dense="true"
                            :items="typeOptions"
                            :currentValue="form.format"
                            :itemText="`text`"
                            :itemValue="`value`"
                          />
                        </v-col>
                        <v-col>
                          <custom-select
                            label="Frequência"
                            v-model="currentPlan.frequency"
                            :dense="true"
                            :items="frequencies"
                            :currentValue="form.frequency"
                            :itemText="`text`"
                            :itemValue="`value`"
                          />
                        </v-col>
                        <v-col>
                          <custom-select
                            label="Tempo de aula"
                            v-model="classTime"
                            :dense="true"
                            :items="times"
                            :currentValue="classTime"
                            :itemText="`text`"
                            :itemValue="`value`"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row
                    no-gutters
                    class="ma-0 pa-0 d-flex align-center justify-center"
                  >
                    <h4>Cronograma</h4>
                  </v-row>
                  <v-row
                    class="ma-0 pa-0"
                    dense
                    v-for="(item, index) in normalizedTimes"
                    :key="index"
                  >
                    <v-col
                      cols="12"
                      md="2"
                      class="d-flex align-center justify-center"
                    >
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col
                          ><custom-select
                            label="Dia da semana"
                            :dense="true"
                            :items="weekDaysItems"
                            :currentValue="item.weekDay"
                            disabled
                        /></v-col>
                        <v-col
                          ><custom-select
                            label="Horário de início"
                            :dense="true"
                            :items="startHours"
                            :currentValue="item.start"
                            disabled
                        /></v-col>
                        <v-col
                          ><custom-select
                            label="Horário de término"
                            :dense="true"
                            :items="endHours"
                            :currentValue="item.end"
                            disabled
                        /></v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-tabs
                    v-model="tab"
                    centered
                    icons-and-text
                    background-color="transparent"
                  >
                    <v-row dense>
                      <v-col
                        class="d-flex align-center"
                        v-for="(item, index) in form.content"
                        :key="index"
                      >
                        <v-tab> {{ item.name }} </v-tab>
                      </v-col>
                    </v-row>
                    <v-tabs-items
                      v-model="tab"
                      style="background-color: transparent"
                    >
                      <v-tab-item
                        v-for="(student, index) in form.content"
                        :key="index"
                      >
                        <v-card style="background-color: transparent">
                          <v-card-text style="background-color: transparent">
                            <v-row
                              ><v-col
                                cols="12"
                                md="2"
                                class="d-flex flex-column"
                                ><v-avatar
                                  size="150"
                                  style="background-color: whitesmoke"
                                >
                                  <v-img
                                    :src="form.content[index].avatar"
                                    height="20vh"
                                    contain
                                  />
                                </v-avatar>

                                <v-btn
                                  v-if="form.content[index].status === 0"
                                  class="ma-2"
                                  color="success"
                                  rounded
                                  small
                                  circle
                                  :loading="loadingSave"
                                  @click="openDialog(form.content[index])"
                                  >Aceitar aluno</v-btn
                                >
                                <v-btn
                                  v-if="form.content[index].status === 0"
                                  class="ma-2"
                                  color="error"
                                  rounded
                                  small
                                  outlined
                                  :loading="loadingReject"
                                  @click="reject(form.content[index])"
                                  >Recusar Aluno</v-btn
                                >
                                <v-btn
                                  v-if="form.content[index].status === 1"
                                  class="ma-2"
                                  color="success"
                                  rounded
                                  small
                                  outlined
                                  :loading="loadingSave"
                                  @click="form.content[index].id;"
                                  ><v-icon>mdi-swap-horizontal</v-icon>Trocar de
                                  Turma</v-btn
                                >
                                <v-btn
                                  v-if="form.content[index].status === 1"
                                  class="ma-2"
                                  color="error"
                                  rounded
                                  small
                                  outlined
                                  :loading="loadingReject"
                                  @click="reject(form.content[index].id)"
                                  ><v-icon>mdi-delete-outline</v-icon>Remover
                                  Aluno</v-btn
                                >
                              </v-col>
                              <v-col class="d-flex align-center justify-center">
                                <v-row v-if="form.content[index].status === 0">
                                  <v-col class="d-flex flex-column">
                                    <custom-input
                                      label="Email"
                                      :currentValue="form.content[index].email"
                                      disabled
                                    />
                                    <custom-input
                                      label="Bio"
                                      :currentValue="form.content[index].bio"
                                      disabled
                                    />
                                  </v-col>
                                </v-row>
                                <v-row
                                  dense
                                  class="mt-1"
                                  v-if="form.content[index].status === 1"
                                >
                                  <v-col class="d-flex flex-column">
                                    <custom-select
                                      label="Mensalidade"
                                      :dense="true"
                                      :items="[
                                        { text: 'Igual para todos', value: 1 },
                                      ]"
                                      :currentValue="1"
                                      disabled
                                    />
                                    <custom-select
                                      label="Vencimento"
                                      :dense="true"
                                      :items="[
                                        { text: 'Todo dia 5', value: 1 },
                                      ]"
                                      :currentValue="1"
                                      disabled
                                    />
                                  </v-col>
                                  <v-col class="d-flex flex-column">
                                    <custom-select
                                      label="Valor"
                                      :dense="true"
                                      :items="[{ text: 'R$ 180', value: 1 }]"
                                      :currentValue="1"
                                      disabled
                                    />
                                    <custom-select
                                      label="Pagamento"
                                      :dense="true"
                                      :items="[{ text: 'Crédito', value: 1 }]"
                                      :currentValue="1"
                                      disabled
                                    />
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12" md="6">
                                <strong class="glowingText"
                                  >Frequência: Em breve!</strong
                                >
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
            <confirm-student-dialog
              ref="confirmDialog"
              :title="'Aceitar '"
              :items="classDays"
              :selectedItem="selected"
              :displayDates="normalizedTimes"
              @confirmed="admit"
            />
          </v-row>
        </v-form>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import partnerApi from "@/shared/pitchPartnerApi";
import { hours } from "@/shared/hours";

export default {
  name: "PartnerClassForm",
  computed: {
    subtitle() {
      return this.$route.params.id === "nova-turma"
        ? "Criar nova turma"
        : `${this.form.cod}`;
    },
  },
  async created() {
    this.loading = true;

    await this.loadData();
    this.loading = false;
  },
  data() {
    return {
      classTime: null,
      loadingSave: false,
      loadingReject: false,
      hours,
      tab: 0,
      subTabIndex: 0,
      customer_index: 0,
      valid: false,
      loading: true,
      form: {},
      students: [],
      currentPlan: {},
      selectedPlan: {},
      teachingPlans: [],
      normalizedTimes: [],
      classDays: [],
      dialog: true,
      englishLevels: [
        {
          text: "Beginner 1",
          value: 0,
        },
        {
          text: "Beginner 2",
          value: 1,
        },
        {
          text: "Essential 1",
          value: 2,
        },
        {
          text: "Essential 2",
          value: 3,
        },
        {
          text: "Pre Intermediate 1",
          value: 4,
        },
        {
          text: "Pre Intermediate 2",
          value: 5,
        },
        {
          text: "Intermediate 1",
          value: 6,
        },
        {
          text: "Intermediate 2",
          value: 7,
        },
        {
          text: "Upper 1",
          value: 8,
        },
        {
          text: "Upper 2",
          value: 9,
        },
        {
          text: "Advanced 1",
          value: 10,
        },
        {
          text: "Advanced 2",
          value: 11,
        },
      ],
      typeOptions: [
        { text: "Individual", value: 1 },
        { text: "Dupla", value: 2 },
        { text: "Trio", value: 3 },
        { text: "Quarteto", value: 4 },
      ],
      weekDaysItems: [
        {
          text: "Domingo",
          value: 0,
        },
        {
          text: "Segunda-feira",
          value: 1,
        },
        {
          text: "Terça-feira",
          value: 2,
        },
        {
          text: "Quarta-feira",
          value: 3,
        },
        {
          text: "Quinta-feira",
          value: 4,
        },
        {
          text: "Sexta-feira",
          value: 5,
        },
        {
          text: "Sábado",
          value: 6,
        },
      ],
      frequencies: [
        { text: "Todos os dias", value: 0 },
        { text: "Uma vez na semana", value: 1 },
        { text: "Duas vezes na semana", value: 2 },
        { text: "Três ou mais", value: 3 },
        { text: "A cada 15 dias", value: 4 },
      ],
      times: [
        {
          text: "60 minutos",
          value: 1,
        },
        {
          text: "90 minutos",
          value: 2,
        },
      ],
      startHours: [],
      endHours: [],
      selected: null,
    };
  },
  methods: {
    openDialog(selected) {
      this.selected = selected;
      this.$refs.confirmDialog.open();
    },
    async loadData() {
      this.form = {};
      this.normalizedTimes = [];
      await partnerApi.getOneStudyGroups(this.$route.params.id).then((res) => {
        this.form = res.data;
        this.students = res.data.content;
        this.classDays = this.form.weekDays;
      });

      await partnerApi.getPartnerPlans().then((res) => {
        this.teachingPlans = res.data.data.map((plan) => {
          return {
            value: plan,
            text: `${this.displayFormat(plan.format)} -  R$${plan.value} / Mês`,
          };
        });
        this.setCurrentPlan(
          this.teachingPlans.find(
            (plan) =>
              plan.value.format === this.form.format &&
              plan.value.frequency === this.form.frequency
          )
        );
      });

      await this.normalizeTimes();
    },
    displayFormat(format) {
      switch (format) {
        case 1:
          return "Individual";
        case 2:
          return "Dupla";
        case 3:
          return "Trio";
        case 4:
          return "Quarteto";
      }
    },
    displayTime(time) {
      return time === 1 ? "60 minutos" : "90 minutos";
    },
    displayFrequency(frequency) {
      return `${frequency}x semana`;
    },
    displayLevel(level) {
      return this.englishLevels[level].text;
    },
    displayStatus(format) {
      switch (format) {
        case 0:
          return "Aguardando";
        case 1:
          return "Ativo";
        case 2:
          return "Inativo";
        case 3:
          return "Rejeitado";
      }
    },
    setCurrentPlan(plan) {
      if (plan) {
        this.selectedPlan = plan;
        this.currentPlan = plan.value;
      } else {
        return {};
      }
    },
    normalizeTimes() {
      for (let index = 0; index < this.form.weekDays.length; index++) {
        const element = this.form.weekDays[index];
        if (this.form.hours[index]) {
          this.normalizedTimes.push({
            weekDay: +element,
            start: this.form.hours[index].split("-")[0].trim(),
            end: this.form.hours[index].split("-")[1].trim(),
          });

          this.startHours.push(this.form.hours[index].split("-")[0].trim());
          this.endHours.push(this.form.hours[index].split("-")[1].trim());
        }
      }
      const startTime = this.startHours[0];
      const endTime = this.endHours[0];

      const [startHours, startMinutes] = startTime.split(":").map(Number);
      const [endHours, endMinutes] = endTime.split(":").map(Number);

      const startTotalMinutes = startHours * 60 + startMinutes;
      const endTotalMinutes = endHours * 60 + endMinutes;

      const differenceInMinutes = endTotalMinutes - startTotalMinutes;

      this.classTime = +differenceInMinutes > 50 ? 2 : 1;
    },
    async admit(weekDay) {
      this.loadingSave = true;
      return await partnerApi
        .udpateRequest(this.$route.params.id, {
          customer: this.selected.id,
          status: 1,
          weekDay,
        })
        .then(async () => {
          this.$root.$emit("display-alert", {
            text: "Ótimo, você aceitou o aluno na sua turma!",
            type: 0,
          });
          await this.loadData();
          this.loadingSave = false;
        })
        .catch(() => {
          this.loadingSave = false;
          this.$root.$emit("display-alert", {
            text: "Ocorreu um erro inesperado, tente novamente mais tarde.",
            type: 1,
          });
        });
    },
    async reject(id) {
      this.loadingreject = true;
      return await partnerApi
        .updateRequest(this.$route.params.id, {
          customer: id,
          status: 4,
        })
        .then(() => {
          this.loadingreject = false;
          this.$root.$emit("display-alert", {
            text: "A entrada do aluno a turma foi recusada.",
            type: 1,
          });
        })
        .catch(() => {
          this.loadingreject = false;
          this.$root.$emit("display-alert", {
            text: "Ocorreu um erro inesperado, tente novamente mais tarde.",
            type: 1,
          });
        });
    },
  },
};
</script>

<style lang="css" scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.normal {
  text-transform: none;
}

.toolbar {
  background-image: url("@/assets/images/unsplash_professor.webp");
  background-size: cover;
  background-repeat: no-repeat;
}

.gradientTitle {
  background: linear-gradient(to right, #e8276f, #9923cd);

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  animation: moveGradient 3s linear infinite;
}

.glowingText {
  animation: glowText 0.8 ease-in-out infinite alternate;
}

@keyframes moveGradient {
  0% {
    background-position: 50% 0;
  }

  50% {
    background-position: 0 0;
  }

  100% {
    background-position: 100% 0;
  }
}
</style>
